export default {"src":"/minerva/_next/static/media/logo.5c93a448.svg","height":181,"width":181,"blurWidth":0,"blurHeight":0};